import React from 'react';

const SvgGn = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="GN_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="GN_svg__b" fill="#fff">
        <use xlinkHref="#GN_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#GN_svg__a" />
      <path fill="#1DBE5E" mask="url(#GN_svg__b)" d="M13.333 0H28v20H13.333z" />
      <path fill="#E72B42" mask="url(#GN_svg__b)" d="M0 0h9.333v20H0z" />
      <path
        fill="#FFD952"
        mask="url(#GN_svg__b)"
        d="M9.333 0h9.333v20H9.333z"
      />
    </g>
  </svg>
);

export default SvgGn;
